const messages = {
  step3: {
    actionBtn: "Conectare",
  },
};

export default {
  messages,
};
